'use client';
import { PageLayout } from '@ui/components/layouts';
import { text } from '@modules/garden-config/text';

import type { Garden } from '@modules/garden-config/models';

import { PageContentLoading } from '@/src/components/PageContentLoading';
import { PageHeaderWithGardenSelector } from '@/src/components/PageHeaderWithGardenSelector';

import type { ReactNode } from 'react';

export interface GardenConfigViewProps {
  isLoading: boolean;
  gardens: Garden[];
  selectedGarden: Garden | null;
  selectedGardenId: string | null;
  onGardenChange: (gardenId: string | null) => void;
  sowingContent: ReactNode;
}

export function GardenConfig({
  isLoading,
  gardens,
  selectedGarden,
  selectedGardenId,
  onGardenChange,
  sowingContent,
}: GardenConfigViewProps) {
  if (isLoading) {
    return <PageContentLoading />;
  }

  return (
    <PageLayout maxWidth={1280}>
      <PageHeaderWithGardenSelector
        title={text.title}
        description={text.description}
        gardens={gardens}
        selectedGardenId={selectedGardenId}
        onGardenChange={onGardenChange}
        gardenSelectLabel={text.selectGarden}
      />

      {selectedGarden && <div className="flex flex-col gap-4">{sowingContent}</div>}

      {!selectedGarden && gardens.length > 0 && (
        <div className="flex flex-col items-center py-10">
          <p className="text-muted-foreground text-xl font-medium">{text.selectGardenPrompt}</p>
        </div>
      )}

      {gardens.length === 0 && (
        <div className="flex flex-col items-center py-10">
          <p className="text-muted-foreground text-xl font-medium">{text.noGardens}</p>
        </div>
      )}
    </PageLayout>
  );
}
